import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Breadcrumb, Table, CardHeader, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom'; // Assuming React Router is used
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import CustomConfirmPopup from "../../components/CustomConfirmPopup";
import { Tooltip } from 'primereact/tooltip';
import successVideo from '../../assets/video/paperplane.mp4';
import crossVideo from '../../assets/video/cross.mp4';
import { ProgressSpinner } from 'primereact/progressspinner';
import GifLoder from '../../components/GifLoder';
const Template_invoice_list = () => {
    const { accessToken } = useAuth();
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mainloading, setmainLoading] = useState(true);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [headerLogo, setHeaderLogo] = useState(null);
    const [signature, setSignature] = useState(null);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    // Fetch templates from the API
    const fetchTemplates = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/templateRoutes/alltemplates`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
    
            const fetchedTemplates = response.data.templates;
            setTemplates(fetchedTemplates);
    
            // Set the first template as the default selected template
            if (fetchedTemplates.length > 0) {
                setSelectedTemplate(fetchedTemplates[0]);
            }
        } catch (error) {
            console.error('Error fetching templates:', error);
        } finally {
            setmainLoading(false);
        }
    };
    

    useEffect(() => {
        fetchTemplates();
    }, [accessToken]);




    const handleFileChange = (e, type) => {
        if (type === 'headerLogo') {
            setHeaderLogo(e.target.files[0]);
        } else if (type === 'signature') {
            setSignature(e.target.files[0]);
        }
    };

    const handleSubmit = async () => {
        if (!headerLogo || !signature) {
            setVideocrossDialogVisible(true); // Show error dialog
            setTimeout(() => setVideocrossDialogVisible(false), 5000);
            return;
        }
    
        setmainLoading(true);
    
        const formData = new FormData();
        formData.append('signatureFile', signature);
        formData.append('headerLogoFile', headerLogo);
    
        try {
            const response = await axios.post(
                `${config.apiBASEURL}/templateRoutes/duplicate-template/${selectedTemplateId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
    
            if (response.status === 200 || response.status === 201) {

    
                setShowDialog(false); // Close dialog
            }
    
            // Optional re-fetch for consistency
            fetchTemplates();
        } catch (err) {
            console.error('Error duplicating template:', err);
        } finally {
            setmainLoading(false);
        }
    };
    




    const handleDuplicateClick = (templateId) => {
        setSelectedTemplateId(templateId);
        setShowDialog(true);
    };


    const handleDelete = async (templateId) => {
        try {
            setmainLoading(true); // Show loading state
    
            // Send DELETE request
            const response = await axios.delete(
                `${config.apiBASEURL}/templateRoutes/delete-template/${templateId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
    
            if (response.status === 200 || response.status === 201) {
                // Optimistically update the UI
                setTemplates((prevTemplates) =>
                    prevTemplates.filter((template) => template.template_id !== templateId)
                );
    
                setVideoDialogVisible(true); // Show success dialog
                setTimeout(() => setVideoDialogVisible(false), 5000);
    
                // Optional re-fetch
                fetchTemplates();
            }
        } catch (error) {
            console.error('Error deleting template:', error);
            setVideocrossDialogVisible(true); // Show error dialog
            setTimeout(() => setVideocrossDialogVisible(false), 5000);
        } finally {
            setmainLoading(false); // Hide loading state
        }
    };
    

    const handleCardClick = (template) => {
        setSelectedTemplateId(template.template_id); // Track the selected template ID
        setSelectedTemplate(template); // Optionally set the selected template if needed
    };



    if (mainloading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }

    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={4} className="mb-4 d-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Invoice Template</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col sm={8} className="mb-4 d-flex justify-content-end align-items-center">
                        <Link to="/Graphe/dashboard/template_invoice_add">
                            <Button
                                label='Template'
                                icon='pi pi-plus'
                                className='py-2'
                                severity='primary'
                            />
                        </Link>
                    </Col>
                    

                        <Col lg={12} className="p-0">
                            <Row className='mx-0'>
                                <Col lg={5} md={5}>
                                    <div className='sticky-top template_inv'>
                                        {templates.map(template => (
                                            <Card
                                                className={`mb-4 h-auto ${selectedTemplateId === template.template_id ? "selected-class" : ""}`}
                                                key={template.template_id}
                                                onClick={() => handleCardClick(template)}
                                            >
                                                <Card.Body className='d-flex justify-content-start align-items-center'>
                                                    <div style={{ width: '140px' }} className='me-3 bg-light p-3 border'>
                                                        <img
                                                            className="w-100"
                                                            src={
                                                                template?.headerLogos?.[0]?.header_logo_url
                                                                    ? template.headerLogos[0].header_logo_url
                                                                    : require("../../assets/images/logo.png")
                                                            }
                                                            alt=''
                                                        />

                                                    </div>
                                                    <div>
                                                        <h6>{template.template_name}</h6>
                                                        <p className='text-secondary mb-0'>
                                                            <small className='d-block'>Prefix : <b className='text-black'>{template.invoice_prefix}</b></small>
                                                            <small>Year : <b className='text-black'>{template.financial_year}</b></small>
                                                        </p>
                                                        <div className='mt-2'>
                                                            <Button
                                                                title='Edit'
                                                                icon='pi pi-pencil'
                                                                className='p-0 border-0'
                                                                severity='primary'
                                                                outlined
                                                                onClick={() => navigate(`/Graphe/dashboard/template_invoice_edit/${template.template_id}`)}
                                                            />
                                                            <Button
                                                                title="Duplicate"
                                                                icon="pi pi-copy"
                                                                className="p-0 border-0 mx-2"
                                                                severity="help"
                                                                outlined
                                                                onClick={() => handleDuplicateClick(template.template_id)}
                                                            />
                                                            <CustomConfirmPopup

                                                                message="Are you sure you want to Delete this Template?"
                                                                icon="pi pi-exclamation-triangle"
                                                                defaultFocus="accept"
                                                                acceptClassName="p-button-danger"
                                                                buttonLabel="Delete"
                                                                title="Delete Template"
                                                                buttonClass="p-button-danger p-button-text"
                                                                className="border-0 p-0 py-2"
                                                                buttonIcon="pi pi-trash"
                                                                onConfirm={() => handleDelete(template.template_id)}
                                                                onReject={() => console.log('Delete action canceled')}
                                                            />

                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        ))}
                                    </div>
                                </Col>
                                <Col lg={7} md={6} className='mb-4'>
                                    <div className="template_sec">
                                        <Card className="p-0">
                                            <div className="inv-Div">
                                                <div className="inv_header">
                                                    <div className="logo_part">
                                                        <img
                                                            src={selectedTemplate && selectedTemplate.headerLogos && selectedTemplate.headerLogos[0] && selectedTemplate.headerLogos[0].header_logo_url
                                                                ? selectedTemplate.headerLogos[0].header_logo_url
                                                                : require("../../assets/images/logo.png")}
                                                            alt=''
                                                        />
                                                    </div>
                                                    <span>
                                                        <b>{selectedTemplate ? selectedTemplate.header_text : 'Template Name'}</b>
                                                    </span>
                                                </div>
                                                <div className="inv_address">
                                                    <div>
                                                        <p><span>BILLED TO :</span> Billing Company Name</p>
                                                        <p><span>Address :</span> Billing Address</p>
                                                        <p><span>GSTIN / UIN :</span> XXXXXXXXXXXXXXX</p>
                                                        <p><span>PAN / IT NO :</span> XXXXXXXXXX</p>
                                                    </div>
                                                    <div>
                                                        <p><span>PROFORMA NO :</span> {selectedTemplate ? selectedTemplate.invoice_prefix : 'NA'} _/{selectedTemplate ? selectedTemplate.financial_year : 'NA'}</p>
                                                        <p><span>ISSUE DATE :</span> NA</p>
                                                        <p><span>GSTIN :</span> {selectedTemplate ? selectedTemplate.GSTIN : 'NA'}</p>
                                                        <p><span>PAN : </span> {selectedTemplate ? selectedTemplate.PAN : 'NA'}</p>
                                                        <p><span>MSME TYPE </span>: {selectedTemplate ? selectedTemplate.MSME_Type : 'NA'} </p>
                                                        <p><span>MSME NO : </span>{selectedTemplate ? selectedTemplate.MSME_Number : 'NA'} </p>
                                                        <p><span>LUT ARN :</span> {selectedTemplate ? selectedTemplate.Lut_Arn_No : 'NA'} </p>
                                                    </div>
                                                </div>
                                                <div className="inv_cost">
                                                    <Table bordered size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Description</th>
                                                                <th>SAC/HSN</th>
                                                                <th>QTY</th>
                                                                <th className="text-end">Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td className="text-end"><span>₹</span></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3} className="text-end">GSTN (12%) </th>
                                                                <td className="text-end"><span>₹</span></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3} className="text-end">TOTAL VALUE (IN FIGURE) </th>
                                                                <td className="text-end"><span>₹</span></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3}>TOTAL VALUE (IN WORDS) </th>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3}>SUPPLY ATTRACT REVERSE CHARGE (YES/NO)</th>
                                                                <td>No</td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3}>PAYMENT DUE DATE:</th>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={3}>Without Payment of Tax under LUT No.</th>
                                                                <td>{selectedTemplate ? selectedTemplate.Lut_Arn_No : 'NA'}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                    <div className="noteText mb-4">

                                                    </div>
                                                    <div className="sign_sec mb-4">
                                                        <div className="note_de">
                                                            <p><b>Remarks :</b></p>
                                                            <p>text......</p>
                                                            <p className="mt-3"><b>Declaration:</b></p>
                                                            <p>
                                                                We declare that this document shows the actual price of the good/services described and that all particulars are true and correct.
                                                            </p>
                                                        </div>
                                                        <div className="sig">
                                                            <p><b>E. & O.E</b></p>
                                                            <img
                                                                src={selectedTemplate && selectedTemplate.signatures && selectedTemplate.signatures[0] && selectedTemplate.signatures[0].signature_url
                                                                    ? selectedTemplate.signatures[0].signature_url
                                                                    : require("../../assets/images/sign_n.png")}
                                                                alt=''
                                                                style={{ width: '80px', height: '80px' }}
                                                            />
                                                            <p><small>{selectedTemplate ? selectedTemplate.signature_bottom_text : 'NA'}</small></p>
                                                        </div>
                                                    </div>
                                                    <div className="bankDet">
                                                        <p><span className="d-block">PAYMENT INFORMATION :</span>PAY BY CHEQUE/DD/RTGS/NEFT IN FAVOUR OF <br /> {selectedTemplate ? selectedTemplate.company_name : 'NA'} </p>
                                                        <p><span className="d-block">BRANCH : </span> {selectedTemplate ? selectedTemplate.bank_branch : 'NA'}</p>
                                                        <p><span>BANK :</span> {selectedTemplate ? selectedTemplate.bank_name : 'NA'}</p>
                                                        <p><span>A/C NO  :</span> {selectedTemplate ? selectedTemplate.account_number : 'NA'}</p>

                                                        <p><span>IFSC CODE : </span> {selectedTemplate ? selectedTemplate.ifsc_code : 'NA'}</p>
                                                        <p><span>SWIFT CODE : </span>  {selectedTemplate ? selectedTemplate.swift_code : 'NA'}</p>
                                                        {/* <p><span>LUT ARN : </span> HDFCINBB</p> */}
                                                    </div>
                                                </div>
                                                <div className="pdf-footer mt-4">
                                                    <p><small>{selectedTemplate ? selectedTemplate.company_address : 'NA'}</small></p>
                                                    <p><small>Call: {selectedTemplate ? selectedTemplate.contact_no : 'NA'} | Email: <a>{selectedTemplate ? selectedTemplate.email : 'NA'}</a></small></p>
                                                </div>

                                            </div>
                                        </Card>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                </Row>
            </Row>


            <Dialog
                header="Duplicate"
                visible={showDialog}
                onHide={() => setShowDialog(false)}
                closable={false}
                style={{ width: '320px' }}
            >
                <div className="p-fluid grid">
                    {/* Row 1: Header Logo */}
                    <div className="col-12 md:col-6 px-1 mb-3">
                        <label htmlFor="headerLogo" className='d-block mb-2'>Logo
                            <i
                                className="pi pi-info-circle text-warning custom-target-icon ms-2"
                                data-pr-tooltip="Note: New Logo is required for Template Duplication."
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2"
                            ></i>
                            <Tooltip target=".custom-target-icon" />
                        </label>
                        <input
                            type="file"
                            id="headerLogo"
                            name="headerLogo"
                            accept="image/*"
                            onChange={(e) => handleFileChange(e, 'headerLogo')}
                        />
                    </div>

                    {/* Row 2: Signature */}
                    <div className="col-12 md:col-6 px-1 mb-3">
                        <label htmlFor="signature" className='d-block mb-2'>Signature
                            <i
                                className="pi pi-info-circle text-warning custom-target-icon ms-2"
                                data-pr-tooltip="Note: New Signature is required for Template Duplication."
                                data-pr-position="right"
                                data-pr-at="right+5 top"
                                data-pr-my="left center-2"
                            ></i>
                            <Tooltip target=".custom-target-icon" />
                        </label>
                        <input
                            type="file"
                            id="signature"
                            name="signature"
                            accept="image/*"
                            onChange={(e) => handleFileChange(e, 'signature')}
                        />
                    </div>

                    {/* Row 3: Buttons */}
                    <div className="col-12 d-flex justify-content-end mt-3">
                        <Button
                            label="Cancel"
                            severity='danger'
                            onClick={() => setShowDialog(false)}
                            className="p-button-text mr-2 py-2"
                        />
                        <Button
                            label="Submit"
                            severity='success'
                            className='py-2'
                            onClick={handleSubmit}
                            loading={loading}
                        />
                    </div>
                </div>
            </Dialog>
            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default Template_invoice_list;